import { Box, Button, Flex, Heading, Icon, Text } from "@chakra-ui/react";
import { FC } from "react";
import { BsMailbox } from "react-icons/bs";

interface ResetPasswordSuccessfulProps {
  onBack: () => void;
}

const ResetPasswordSuccessful: FC<ResetPasswordSuccessfulProps> = ({
  onBack,
}) => {
  return (
    <Box display="flex" width="100%" flexDirection="column" gap={8}>
      <Flex gap={4} direction="column">
        <Icon as={BsMailbox} width="78px" height="78px" />
        <Heading as="h1">Email de redefinição de senha enviado</Heading>
        <Text size="md">
          Enviámos um email com instruções para redefinir a sua senha para o
          endereço que nos forneceu. Verifique a sua caixa de entrada e siga as
          instruções no email.
        </Text>
      </Flex>
      <Button type="button" alignSelf="flex-start" onClick={onBack}>
        Voltar à Entrada
      </Button>
    </Box>
  );
};

export default ResetPasswordSuccessful;
